var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoldersHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 11.6667C14.6654 12.0203 14.5249 12.3594 14.2748 12.6095C14.0248 12.8595 13.6857 13 13.332 13H2.66536C2.31174 13 1.9726 12.8595 1.72256 12.6095C1.47251 12.3594 1.33203 12.0203 1.33203 11.6667V2.33333C1.33203 1.97971 1.47251 1.64057 1.72256 1.39052C1.9726 1.14048 2.31174 1 2.66536 1H5.9987L7.33203 3H13.332C13.6857 3 14.0248 3.14048 14.2748 3.39052C14.5249 3.64057 14.6654 3.97971 14.6654 4.33333V11.6667Z",
    stroke: "#14142B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldersHover);
export default __webpack_public_path__ + "static/media/folders-hover.3b81c1b363b7c4f594eae7236678f2f5.svg";
export { ForwardRef as ReactComponent };